import { urlServer } from '../mapboxgl/index.js'
//const urlServer='http://ec2-34-221-108-190.us-west-2.compute.amazonaws.com'
//const urlServer='http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com'
//const urlServer='http://localhost:3000'
export const getMapInterval = async (param) =>{
    try{
        let url = `${urlServer}/api/intervalEstado?annio=${param['annio']}&pais=${param['pais']}&intervalTipo=${param['intervalTipo']}&intervalNum=${param['intervalNum']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
export const getMapMunicipio = async (param) =>{
    try{
        let url = `${urlServer}/api/intervalMunicipio?annio=${param['annio']}&pais=${param['pais']}&estado=${param['estado']}&intervalTipo=${param['intervalTipo']}&intervalNum=${param['intervalNum']}&sensor=${param['sensor']}&pcFiltro=${param['pcFiltro']}`
        const response = await fetch(url)
        return await response.json()
    }catch(err){
        return err
    }
}
//intervalTipo,intervalNum